export default __webpack_public_path__ + "static/media/training.fb02ddca.jpg";